export const VIEW_TABS = [
	{ name: "common:field.name", sortKey: "name" },
	{ name: "dsi.form-studio.view.header-title.criteria" },
	{ name: "dsi.form-studio.view.header-title.projects" },
	{ name: "dsi.form-studio.view.header-title.companies" },
];
export const CRITERIA_TABS = [
	{ name: "common:field.name", sortKey: "name" },
	{ name: "dsi.form-studio.criteria.header-title.type" },
	{ name: "dsi.form-studio.criteria.header-title.views" },
	{ name: "dsi.form-studio.criteria.header-title.agent" },
];
